import { render } from "./CounterpartiesPage.vue?vue&type=template&id=58c4f64c"
import script from "./CounterpartiesPage.vue?vue&type=script&lang=js"
export * from "./CounterpartiesPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CounterpartiesPage.vue?vue&type=style&index=0&id=58c4f64c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__